<template>
  <div class="page-card order-commission-page">
    <div class="page-head">
      <h2 class="page-title">订单抽成配置</h2>
      <el-button :loading="loading" @click="fetchData">刷新</el-button>
    </div>

    <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="commission-form">
      <el-form-item label="订单抽成">
        <el-switch v-model="form.enabled" active-text="启用" inactive-text="停用" />
      </el-form-item>
      <el-form-item label="抽成比例" prop="chargeRate">
        <el-input-number v-model="form.chargeRate" :min="0" :max="100" :precision="2" :step="0.5" />
        <span class="unit">%</span>
      </el-form-item>
      <el-form-item label="更新时间">
        <span>{{ currentRule.updatedAt || '-' }}</span>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.trim="form.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="saveConfig">保存配置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  createPlatformCommissionRule,
  getPlatformCommissionRules,
  savePlatformCommissionRule
} from '../../../api/platformManage'

const DEFAULT_RULE_CODE = 'ORDER_COMMISSION_DEFAULT'
const DEFAULT_RULE_NAME = '订单完成抽成'

export default {
  name: 'OrderCommissionPage',
  data() {
    return {
      loading: false,
      saving: false,
      currentRule: {},
      form: {
        enabled: true,
        chargeRate: 0,
        remark: ''
      },
      rules: {
        chargeRate: [{ validator: this.validateChargeRate, trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const rules = await getPlatformCommissionRules({ applicableScope: 1 }) || []
        const rule = rules.find(item => item.ruleCode === DEFAULT_RULE_CODE) || rules[0] || {}
        this.currentRule = rule
        this.form = {
          enabled: Number(rule.ruleStatus == null ? 1 : rule.ruleStatus) === 1,
          chargeRate: Number(rule.chargeRate || 0),
          remark: rule.remark || ''
        }
        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.clearValidate()
        })
      } finally {
        this.loading = false
      }
    },
    validateChargeRate(rule, value, callback) {
      if (!this.form.enabled) {
        callback()
        return
      }
      const rate = Number(value || 0)
      if (rate <= 0 || rate > 100) {
        callback(new Error('启用后抽成比例需大于0且不超过100'))
        return
      }
      callback()
    },
    buildPayload() {
      return {
        ruleName: DEFAULT_RULE_NAME,
        ruleCode: DEFAULT_RULE_CODE,
        applicableScope: 1,
        merchantUserId: null,
        noticeType: null,
        noticeId: null,
        chargeMode: 1,
        chargeRate: Number(this.form.chargeRate || 0),
        fixedAmount: null,
        ruleStatus: this.form.enabled ? 1 : 0,
        effectiveAt: null,
        expiredAt: null,
        remark: this.form.remark || ''
      }
    },
    saveConfig() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const payload = this.buildPayload()
          if (this.currentRule.id) await savePlatformCommissionRule(this.currentRule.id, payload)
          else await createPlatformCommissionRule(payload)
          this.$message.success('订单抽成配置已保存')
          await this.fetchData()
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.commission-form {
  max-width: 560px;
  margin-top: 24px;
}

.unit {
  margin-left: 8px;
  color: #606266;
}
</style>
